export default __webpack_public_path__ + "static/media/microsoft-logo.38a2369c.svg";